// Read more about this way of fetching data
// https://redux.js.org/advanced/async-actions#actions-js-with-fetch

import {loadPartsRequest, loadPartsSuccess, deletePartsRequest} from './actionCreators';
import fetch from 'cross-fetch';
import ApiService from '../services/api';
import { showSnackbar } from "../actions/snackbarActions";


export function loadParts() {
  return (dispatch, getState) => {
    let state = getState();
    return dispatch(getParts(state))
  }
}

function getParts(state) {
  let token = state.oidc.user.access_token;

  return dispatch => {
    dispatch(loadPartsRequest())
    return fetch(process.env.API_URL + '/api/Parts', {
      headers: {
        'Authorization': 'Bearer ' + token
      }})
      .then(response => response.json())
      .then(json => dispatch(loadPartsSuccess(json)))
  }
}


export const createNew = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const newPart = await apiService.createNew("parts", content);
      dispatch({
        type: 'ADD_PART_REQUEST',
        data: newPart
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const editPart = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const editedPart = await apiService.edit("parts", content);
      dispatch({
        type: "PARTS_EDIT_PART",
        data: editedPart
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const deletePart = (content) => {
  return async (dispatch, getState) => {
    try {
      dispatch(deletePartsRequest(true));
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const deletedPartId = await apiService.delete("parts", content);
      await dispatch({
        type: "PARTS_DELETE_PART",
        data: deletedPartId
      });
      dispatch(showSnackbar("Part deleted"))
      dispatch(deletePartsRequest(false));
    }
    catch (err) {
      dispatch(showSnackbar("Error: Part delete failed"));
      dispatch(deletePartsRequest(false));
      //throw Error(err);
    }
  }
}

export const loadPartTypesAsync = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;
    try {
      let apiService = new ApiService(token);
      const partTypes = await apiService.getAll("partTypes");
      return partTypes;
    }
    catch (ex) {
      console.error(ex);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/partActions.js